import { render, staticRenderFns } from "./importemp.vue?vue&type=template&id=8348cb5a&scoped=true&"
import script from "./importemp.vue?vue&type=script&lang=js&"
export * from "./importemp.vue?vue&type=script&lang=js&"
import style0 from "./importemp.vue?vue&type=style&index=0&id=8348cb5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8348cb5a",
  null
  
)

export default component.exports